import React, { useState } from 'react';

import LoadingSvg from '@/components/common/LoadingSvg';
import EasyPayBalanceRemaining from '@/components/myaccount/Components/EasyPayBalanceRemaining';
import { useUpcomingPayments } from '@/components/myaccount/hooks/useEasyPaySchedule';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

import EasyPayUpcomingPayments from '../Components/EasyPayUpcomingPayments';

export const EasyPay = () => {
    const [openItems, setOpenItems] = useState<string[]>(['upcoming-payments']);
    const isAuthenticated = useAuthenticated();
    const { data, isLoading, error } = useUpcomingPayments(isAuthenticated, 1, 10);

    // Loading state
    if (isLoading) {
        return (
            <div className="easypay px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">
                    Your Easy Pay schedule
                </h1>
                <div className="flex min-h-96 items-center justify-center bg-white">
                    <div className="flex flex-col items-center">
                        <LoadingSvg />
                        Loading Easy Pay Schedule
                    </div>
                </div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="easypay px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">
                    Your Easy Pay schedule
                </h1>
                <div className="flex min-h-96 items-center justify-center bg-white">
                    <div className="flex flex-col items-center text-red-600">Error Loading EasyPay</div>
                </div>
            </div>
        );
    }

    // No data state
    if (!data || !data.Paging || !data.InstallmentOrders || data.InstallmentOrders.length === 0) {
        return (
            <div className="easypay px-5 pb-12 text-sm font-light leading-6 md:px-0">
                <h1 className="m-0 pb-8 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">
                    Your Easy Pay schedule
                </h1>
                <p className="text-sm font-semibold">No upcoming Easy Pay Payment</p>
                <h2 className="text-sm font-semibold">Learn about EASY PAY</h2>
                <p className="leading-6">
                    Choose to pay your order in monthly installments. No interest, No hidden fees, No small print. No
                    worries! Shipping and taxes will be added to your first payment.
                </p>
                <p>
                    The balance owing will be charged in equal payments in 30-day intervals after the date of purchase.
                    When purchasing online, we offer Easy Pay payments that are based on the total value of your order.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="easypay px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">
                    Your Easy Pay schedule
                </h1>
                <div className="min-h-[700px]">
                    <Accordion type="multiple" className="w-full" value={openItems} onValueChange={setOpenItems}>
                        <AccordionItem value="balance-remaining">
                            <AccordionTrigger>Balance Remaining (By Month)</AccordionTrigger>
                            <AccordionContent>
                                <EasyPayBalanceRemaining isOpen={openItems.includes('balance-remaining')} />
                            </AccordionContent>
                        </AccordionItem>
                        <AccordionItem value="upcoming-payments" id="easypay-scroll-position">
                            <AccordionTrigger>Upcoming Payments (By Order)</AccordionTrigger>
                            <AccordionContent>
                                <EasyPayUpcomingPayments />
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
            {/* Portal container for popovers - placed at high level to escape all stacking contexts */}
            <div id="easypay-popover-portal" style={{ position: 'fixed', zIndex: 10000, pointerEvents: 'none' }}>
                {/* Child elements will have pointerEvents: 'auto' */}
            </div>
        </>
    );
};

export default EasyPay;
